import React, {useState, useEffect} from 'react'
import { Breadcrumb, Heading, Spinner } from '../common/atoms'
import { Row, Col, Card, Tooltip } from 'antd';
import {successOrFailureToaster} from '../common/atoms/messages';
import { TestMailModal, PopUpModals, LaunchMailerModal, FailModal } from '../modals';
import {  useHistory } from 'react-router-dom';
import { companyMailerApi, employeeDataApi } from '../../services';
import { handleAppError } from '../handlers';
import { EMAIL_REGEX, DAYS, MONTHS, LAUNCH_MAILER_RELEASE_DATE} from '../../constants/companyMailer';
import { emailer, review_mailer, static_confetti, 
        confetti, close_icon, close_copy, mile_stone,  
        upArrow, downArrow,
        file} from '../../assets/images';
import moment from 'moment';
import MailerCard from '../common/organisms/MailerCard';
import styled, { keyframes } from 'styled-components';
import {
  dsButtonDisabledTextAction,
  dsButtonGhostBrand,
  dsButtonSecondary,
  dsButtonTextAction,
  joinButtonClasses,
} from '../../utils/buttonStyles';


const vibrate = keyframes`
  0% { transform: translateY(-4px); }
  25% { transform: translateY(-2px); }
  50% { transform: translateY(0px); }
  75% { transform: translateY(2px); }
  100% { transform: translateY(4px); }
`;

const VibratingArrow = styled.img`
  width: 14px;
  height: 14px;
  transition: transform 0.3s ease;
  margin-right: 8px;
  animation: ${vibrate} 0.5s ease-in-out infinite;
`;

const MailLandingPage = (props) => {
    const [pageloading, setPageLoading] = useState(true);
    let suState = {mail_count: 1, delivery: {}, engagement: {}, sent: false, type: '', grade_variants: []}
    const [stats, setStats] = useState({teaser: suState, pre_launch: suState, launch: suState});
    const [test, setTest] = useState({mail: '', testMail: false, data: {}});
    let subState = {id: 0, subject: '',sender: '', preview: '', updated_at: '', content: '', sent_at: 'rt', grade: null, grade_variants: [], status: '', schedule_time: ''}
    const [state, setState] = useState({
      teaser: subState,
      pre_launch: subState,
      launch: subState
    })
    const [sendModal, setSendModal] = useState({send: false, type: '', launch: false, launchSent: false, employee_count: {base: 0}, activate: 0, disable: false})
    const [collapsed, setCollapsed] = useState(false);
    const [cloneModal, setCloneModal] = useState({dataId: 0, open: false, data: {}, mailerName: ''});
    const history = useHistory();

    useEffect(() => {
      if(sessionStorage.getItem('launch_date') < LAUNCH_MAILER_RELEASE_DATE){
        history.push('/overview')
      }
      
      fetchMailers();
      fetchInsigths();
      setPageLoading(false)
  }, [])


  const fetchMailers = () => {
    const options = {}
    companyMailerApi.mail_steup(
        options,
        (res) =>{
            let data = res.data.mailer
            setState((prevValues) => {
              return {...prevValues, ...data}
            }) 
        },
        (err) => handleAppError(err)
    );
  };

  const fetchInsigths = () => {
    let active_emp = 0;
    let launch_date = sessionStorage.getItem('launch_date')
    employeeDataApi.fetch_manage_employee_metric_card({} , 
      (res) =>{
        let data = res.data 
        active_emp = data.active_users_session_count;
      },
      (error) => handleAppError(error)
    )
    const options = {}
    companyMailerApi.mailer_insights(
      options,
      (res) => {
        if(res.data.stats){
          setStats(res.data.stats);
          setSendModal((prev) => {
            return{...prev,...{employee_count: res.data.employee_count, activate: active_emp}}
          })
          let data = res.data.stats;
          let popup = sessionStorage.getItem('popUp')
          if((moment(new Date()).format("YYYY-MM-DD") >= launch_date && data.launch?.sent === false && (popup !== 'stop'))) {
            let subState = { launch: !sendModal.launch, type: 'launch'}
            setSendModal((prev) => {
              return{...prev,...subState}
            });
          }
        }
      },
      (err) => {
        handleAppError(err)
      }
    )
  }
  
    const sendTest = () => {
      console.log(test, 'test.mail')
        if(handleValidation(test.mail)){
          test.mail.split(',').map((mail) => {
          const options = { id: test.data.id, data: {...test.data, email: mail.trim()} }

          companyMailerApi.test_mail(
            options,
            (res) => {
              if(res.data.message === "success"){
                let message = `Test email sent successfully to: ${test.mail.replace(',',', ')}`
                successOrFailureToaster({ message, type: 'success'})
                setTest((prev) => { return {...prev,...{testMail: false}}})
                history.push('/mailer')
              }else{
                successOrFailureToaster({message: 'Something when wrong! Try again', type: 'fail'})
              }
            },
            (err) => handleAppError(err)
          )
        })
        }else{
          alert('Not a valid email address.')
        }
    }


    const cloneMailer = () => {
      let data = cloneModal.data;
      setPageLoading(true);
      companyMailerApi.clone_mailer(
        {id: data.id},
        (res) => {
          console.log(res.data)
          if(res.data.message === "success"){
            let message = `${cloneModal.mailerName} Mailer cloned successfully`
            successOrFailureToaster({ message, type: 'success'})
            setCloneModal((prev) => {return {...prev, open: false}})
            fetchMailers()
          }else{
            successOrFailureToaster({message: 'Something when wrong! Try again', type: 'fail'})
            setCloneModal((prev) => {return {...prev, open: false}})
          }
        },
        _ => {
          successOrFailureToaster({message: 'Something when wrong! Try again', type: 'fail'})
          setCloneModal((prev) => {return {...prev, open: false}})
        }
      )
      setTimeout(() => { setPageLoading(false);

      }, 500);
  }

  const getStatusColor = (status) => {
    switch (status) {
      case "draft":       // blue tone
        return { background: '#EFF6FF', color: '#475569' };
      case "scheduled":   // also blue tone
        return { background: '#EFF6FF', color: '#475569' };
      case "sent":        // green tone
        return { background: '#E6F3F0', color: '#14866D' };
      default:            // gray fallback
        return { background: '#F3F4F6', color: '#6B7280' }; // tailwind: bg-slate-100 text-slate-600
    }
  };

    const handleValidation = (email) => {
      let errors = {};
      let formIsValid = true
      email.split(',').map((mail) => {
      if (!mail.trim().match(EMAIL_REGEX)){
        errors["email"] = "Not a valid email"
        formIsValid = false
      }
      })
      return formIsValid
    }

    const testMailFunc = (e) => {
      let data = test.testMail;
      let subState = {testMail: !data}
      setTest((prevValues) => {
        return{...prevValues,...subState}
      });
    }
  
    const mailStep = (e, type = null) => {
        let data = val(e);
        history.push({
            pathname: '/mail-setup',
            state: { title: e.target.name,
                     backPath: '/mailer',
                     id: data.id,
                     count: employee_count,
                     launch_type: disableGradeSendButton ? null : type
                  }
        })
    }

    const edit_preview = (e) => {
      let data = val(e);
      history.push({
        pathname: '/mail-config',
        state: {id: data.id,
                show: true}
      })
    }

    const sentTestMail = (e) => {
      let data = val(e);
      let subState = {testMail: true, data: data}
      setTest((prev) => {
        return{...prev,...subState}
      })
    }

    const sendMailNowOrLater = (e) => {
      e = e === 'launch' ? e : e.target.name;
      let subState = {}
      if(e === 'teaser 1' || e === 'teaser 2' || e?.split('-')?.[0] === 'teaser 1' || e?.split('-')?.[0] === 'teaser 2'){
        subState = {send: !sendModal.send, type: e || ''}
      }else {
        subState = {launch: !sendModal.launch, type: e || ''}
      }
      setSendModal((prev) => {
        return{...prev,...subState}
      });
    }

    const closeSendModal = () => {
        let subState = {launch: false, send: false}
        setSendModal((prev) => {
          return{...prev,...subState}
        })
        sessionStorage.setItem('popUp','stop');
    }

    const launchMailSent = () => {
      let subState = {launch: false, launchSent: true}
      setSendModal((prev) => {
        return{...prev,...subState}
      })
      mail_sender()
      sessionStorage.setItem('is_active', 'active');
    }

    const launchDone = () => {
      let subState = {launchSent: !sendModal.launchSent}
      setSendModal((prev) => {return{...prev,...subState}})
      window.location.reload()
    }

    const onClone = (data, name) => {
      let subState = {open: true, dataId: data.id, data: data, mailerName: name}
      setCloneModal((prev) => {
        return{...prev,...subState}
      })
    }

    const closeCloneModal = () => {
      let subState = {open: false, dataId: 0}
      setCloneModal((prev) => {
        return{...prev,...subState}
      })
    }
    
    const val = (e) => {
      let event = e.target !== undefined ? e.target.name : e
      let data = {}
      if (event === 'teaser 1'){
          data = state.teaser;
      }else if(event?.split('-')?.[0] === 'teaser 1') {
        data = state.teaser.grade_variants.find((item) => item.id === parseInt(event.split('-')[1]));
      }else if(event === 'teaser 2'){
          data = state.pre_launch;
      }else if(event?.split('-')?.[0] === 'teaser 2') {
        data = state.pre_launch.grade_variants.find((item) => item.id === parseInt(event.split('-')[1]));
      }else if(event === 'launch' || event === 'base'){
          data = state.launch;
      }else if(event?.split('-')?.[0] === 'launch'){
        data = state.launch.grade_variants.find((item) => item.id === parseInt(event.split('-')[1]));
      }else{
        let allLaunchMailers = flattenReplicaMailers(state.launch);
        data = allLaunchMailers.find(item => `${item.grade}-${item.id}` === event);
      }
      return(data);
    }

    const mail_sender = () => {
      let type = sendModal.type;
      setPageLoading(true);
      let data = val(type)
      const options = {id: data.id, params: {launch_type: sendModal.type.split('-')[0]}};
        companyMailerApi.mailer_sender(
          options,
          (res) => {
            if(res.data.message === "success"){
              setSendModal((prev) => {return {...prev,send: false}})
              setPageLoading(false);
              if(type == 'teaser 1' || type == 'teaser 2'){
                let message = 'Congratulations! Your campaign was successfully created. Your campaign is queued to be sent.'
                successOrFailureToaster({ message, type: 'success'})
                window.location.reload()
              }
            }else{
              successOrFailureToaster({message: 'Something when wrong! Try again', type: 'fail'})
              setSendModal((prev) => {return {...prev, disable: true, send: false}})
            }
          },
          (err) => {
            if(err?.response?.data?.message === 'employee count is less than required'){
              let subState = {launch: false, launchSent: false, disable: true, send: false}
              setSendModal((prev) => {return {...prev, ...subState }})
            }else{
              let subState = {launch: false, launchSent: false, disable: false, send: false}
              setSendModal((prev) => {return {...prev, ...subState }})
              handleAppError(err)
            }
          }
        )
      fetchInsigths()
      setPageLoading(false);
    }

    const dateFormat = (val) => {
      let DATE = new Date(val)
      let day = DATE.getDay();
      let date = DATE.getDate();
      let mon = DATE.getMonth()
      let year = DATE.getFullYear();
      let hrs = DATE.getHours()
      let min = DATE.getMinutes()
      let finalDate = `${DAYS[day] || ''}, ${date || ''} ${MONTHS[mon] || ''} ${year || ''} at ${hrs.toString().length > 1 ? hrs : '0'+hrs}:${min.toString().length > 1 ? min : '0'+min}`

      if(val){
        return finalDate
      }else{
        return ''
      }
    }

    function calculateStats(data) {
      const all = [data, ...(data.grade_variants ?? [])];
    
      const keysToSum = ['delivered', 'processed', 'bounce', 'deferred'];
      let sent = 0;
      let delivered_stats = 0;
      let count = 0;
      let open = 0;
    
      all.forEach(entry => {
        const delivery = entry.delivery || {};
        const engagement = entry.engagement || {};
    
        count += entry.mail_count ?? 0;
        sent += keysToSum.reduce((sum, key) => sum + (delivery[key] ?? 0), 0);
        delivered_stats += (delivery?.delivered ?? 0) + (delivery?.processed ?? 0);
        open += (engagement?.open ?? 0) + (engagement?.click ?? 0);
      });
    
      return { count, sent, delivered_stats, open };
    }
    
    const metrics = (data) => {
      if (data){
        const { count, sent, delivered_stats, open } = calculateStats(data);
        
        return(
          <div className='font-semibold float-right flex flex-row'>
            { data.delivery.delivered &&
              <div className='px-5 mx-4 text-center'>
              <div className='uppercase text-xs tracking-widest' style={{color: '#6B7280'}}>SENT</div>
              <div className='text-xl' style={{color: '#0F1115'}}>{Math.trunc(sent/count*100)}%</div>
              <div className='font-normal text-xs' style={{color: '#6B7280'}}>{sent} Emails</div>
            </div>}
            { data.delivery.delivered &&
            <div className='px-4 mx-4 text-center'>
              <div className='text-xs uppercase tracking-widest' style={{color: '#6B7280'}}>Delivered</div>
              <div className='text-xl' style={{color: '#0F1115'}}>{Math.trunc(delivered_stats/count*100)}%</div>
              <div className='font-normal text-xs' style={{color: '#6B7280'}}>{delivered_stats} Emails</div>
            </div>}
            { data.engagement.open &&
            <div className='px-4 mx-4 text-center'>
              <div className='text-xs uppercase tracking-widest' style={{color: '#6B7280'}}>Opened Rate</div>
              <div className='text-xl' style={{color: '#0F1115'}}>{Math.trunc(open/count*100)}%</div>
              <div className='font-normal text-xs' style={{color: '#6B7280'}}>{open} Opened</div>
            </div>}
           { stats.launch?.sent && sendModal.activate > 0 && (data.type === "launch") &&
           <div className='px-5 mx-4 text-center'>
              <div className='text-xs uppercase tracking-widest' style={{color: '#6B7280'}}>Action</div>
              <div className='text-xl' style={{color: '#0F1115'}}>{Math.trunc(sendModal.activate/count*100)}%</div>
              <div className='font-normal text-xs' style={{color: '#6B7280'}}>{sendModal.activate} Activated</div>
            </div>}
          </div>
        )
    }
    }

    const mailerDescription = (name) => {
      switch(name) {
        case 'teaser 1':
          return 'Teaser 1 Replica is a brief email designed to generate excitement and curiosity among employees about the upcoming benefit.'
        case 'teaser 2':
          return 'Teaser 2 Replica is a follow-up email intended to build anticipation and maintain interest ahead of the benefit launch.'
        case 'launch':
          return 'The Launch Mailer Replica is a follow-up communication sent after the official announcement, providing details on how to access the new benefit and outlining its key features.'
        default:
          return 'This is a mailer that provides information about the new benefit.';
      }
    }

    const renderMailerCard = (replicas, name) => (
      replicas.map((data, index) => {
        const { id, subject, status, sent_at, updated_at, insights = {}, content, schedule_time } = data;
        const isSent = status === "sent" && sent_at;
        const isScheduled = status === "scheduled" && schedule_time;
        const { background, color } = getStatusColor(status);
        const disabledSend = !content;
        return (
            <Card id={index} style={{ minHeight: 230, marginTop: 20 }} loading={pageloading} className='overview-card relative'>
            <Row className='font-semibold text-lg'><span className='capitalize'>{name} mailer</span> 
                <span style={{background: background, color: color}} className='rounded-xl px-3 py-1 ml-2 font-semibold text-xs'>
                  {status}
                </span>
            </Row>
            <Row style={{ fontWeight: 400, width: '70%', marginTop: 7}}>
              {mailerDescription(name)}
            </Row>
            { !isSent &&
              <div className='absolute top-6 right-6'>

            <button
                name={`${name}-${id}`}
                type='submit'
                onClick={mailStep}
                className={joinButtonClasses(dsButtonGhostBrand, 'mx-4 h-10 px-4')}
            >
                Edit {`${name?.split(' ')[0]}`}
            </button>
            <Tooltip
              placement='bottomLeft'
              overlayStyle={{maxWidth: '235px'}}
              color={'#0F1115'}
              key='pink'
              title={`${disabledSend ? `Ensure the email content is saved before initiating the ${name} mailer.` : ''}`}
              align
            >
              {!isScheduled &&
                <button name={`${name}-${id}`} type='submit'
                disabled={disabledSend}
                className={joinButtonClasses(dsButtonSecondary, 'h-10 px-4', disabledSend && 'cursor-not-allowed')}
                onClick={sendMailNowOrLater}>
                  Send now
              </button>}
            </Tooltip>
            </div>}
            <Row style={{background: '#EFF6FF80'}} className='my-4 px-3 py-4 rounded border-2'>
                <div className='float-left flex flex-row'>
                  <img src={emailer} alt='#' style={{height: 46, width: 48}}/>
                  <div className='mx-2'>
                    <div className='font-semibold text-base' style={{color: '#0F1115'}}>Subject : {subject}</div>
                    <div className=''><strong className='text-slate-800'>{isSent ? 'Sent' : (isScheduled ? 'Scheduled' : 'Draft')}</strong> {isScheduled ? 'for' :'on'} {isSent ? dateFormat(sent_at) : (isScheduled ? dateFormat(schedule_time) : dateFormat(updated_at))}</div>
                    { !isSent &&
                      <div className='flex items-center'>
                        <button
                          name={`${name}-${id}`}
                          onClick={sentTestMail}
                          disabled={disabledSend}
                          className={joinButtonClasses(dsButtonTextAction, disabledSend && dsButtonDisabledTextAction)}
                        >
                          Send Test Mail
                        </button>
                        <div className="bg-zinc-300 rounded mx-2 w-1 h-1 font-semibold" style={{background: '#D1D5DB'}}></div>
                        <button
                          name={`${name}-${id}`}
                          onClick={edit_preview}
                          disabled={disabledSend}
                          className={joinButtonClasses(dsButtonTextAction, disabledSend && dsButtonDisabledTextAction)}
                        >
                          Preview
                        </button>
                      </div>}
                  </div>
                </div>
                {isSent && metrics(insights)}
            </Row>
          </Card>
        )
      }
  )
);

  const teaserCard = () => {

    return (
      <>
      <Card
        style={{ minHeight: 150, marginTop: 20, background: '#F9FAFB' }}
        loading={pageloading}
        className='overview-card relative'
      >
        <div className="flex justify-between items-center">
          <h4 className="inline-block px-3 py-1 text-sm font-semibold text-purple-700 bg-purple-50 border border-purple-200 rounded-full">
            Teaser 1
          </h4>
          <div className='justify-end flex mb-4'>
              <button
                name='teaser 1'
                type='submit'
                className={joinButtonClasses(dsButtonSecondary, 'h-10 px-4')}
                onClick={() => onClone(state.teaser, 'Teaser 1')}
              >
                Clone mailer
              </button>
          </div>
        </div>
        <Card style={{ minHeight: 230, marginTop: 20 }} loading={pageloading} className='overview-card relative'>
                    <Row className='font-semibold text-lg'>Teaser 1
                        <span style={{background: background(stats.teaser?.sent), color: textColor(stats.teaser?.sent)}} className='rounded-xl px-3 py-1 ml-2 font-semibold text-xs'>
                          {stats.teaser?.sent ? 'Sent' : (state.teaser?.schedule_time ? 'Scheduled' : 'Draft')}
                        </span>
                    </Row>
                    <Row style={{ fontWeight: 400, width: '70%', marginTop: 7}}>
                        Teaser is a short e-mail that creates a buzz among employees about the new benefit they would be receiving.
                    </Row>
                    { !stats.teaser?.sent &&
                      <div className='absolute top-6 right-6'>

                    <button
                        name='teaser 1'
                        type='submit'
                        onClick={mailStep}
                        className={joinButtonClasses(dsButtonGhostBrand, 'mx-4 h-10 px-4')}
                    >
                        Edit teaser
                    </button>
                    <Tooltip
                      placement='bottomLeft'
                      overlayStyle={{maxWidth: '235px'}}
                      color={'#0F1115'}
                      key='pink'
                      title={`${!state.teaser?.content ? 'Ensure the email content is saved before initiating the teaser 1.' : ''}`}
                      align
                    >
                      {state.teaser?.schedule_time ? <></> :
                        <button name='teaser 1' type='submit'
                        disabled={!state.teaser?.content}
                        className={joinButtonClasses(dsButtonSecondary, 'h-10 px-4', !state.teaser?.content && 'cursor-not-allowed')}
                        onClick={sendMailNowOrLater}>
                          Send now
                      </button>}
                    </Tooltip>
                    </div>}
                    <Row style={{background: '#EFF6FF80'}} className='my-4 px-3 py-4 rounded border-2'>
                        <div className='float-left flex flex-row'>
                          <img src={emailer} alt='#' style={{height: 46, width: 48}}/>
                          <div className='mx-2'>
                            <div className='font-semibold text-base' style={{color: '#0F1115'}}>Subject : {state.teaser.subject}</div>
                            <div className=''><strong className='text-slate-800'>{stats.teaser?.sent ? 'Sent on' : (state.teaser?.schedule_time ? 'Scheduled for' : 'Draft on')}</strong> {stats.teaser?.sent ? dateFormat(state.teaser?.sent_at) : (state.teaser?.schedule_time ? dateFormat(state.teaser?.schedule_time) : dateFormat(state.teaser?.updated_at))}</div>
                            { !stats.teaser?.sent &&
                              <div className='flex items-center'>
                                <button
                                  name='teaser 1'
                                  onClick={sentTestMail}
                                  disabled={!state.teaser?.content}
                                  className={joinButtonClasses(dsButtonTextAction, !state.teaser?.content && dsButtonDisabledTextAction)}
                                >
                                  Send Test Mail
                                </button>
                                <div className="bg-zinc-300 rounded mx-2 w-1 h-1 font-semibold" style={{background: '#D1D5DB'}}></div>
                                <button
                                  name='teaser 1'
                                  onClick={edit_preview}
                                  disabled={!state.teaser?.content}
                                  className={joinButtonClasses(dsButtonTextAction, !state.teaser?.content && dsButtonDisabledTextAction)}
                                >
                                  Preview
                                </button>
                              </div>}
                          </div>
                        </div>
                        {stats.teaser?.sent && metrics(stats.teaser)}
                    </Row>
                </Card>
                {state.teaser.grade_variants.length > 0 && (
              <div className='mt-4'>
                <h4 className="inline-block px-3 py-1 mt-4 ml-4 text-sm font-semibold text-blue-700 bg-blue-50 border border-blue-200 rounded-full">
                  Replicas
                </h4>
                {renderMailerCard(state.teaser.grade_variants, 'teaser 1')}
              </div>
            )}
          </Card>
        </>
    )
  };

  const preLaunchCard = () => {
    return(
      <>
        <Card
          style={{ minHeight: 150, marginTop: 20, background: '#F9FAFB' }}
          loading={pageloading}
          className='overview-card relative'
        >
          <div className="flex justify-between items-center">
            <h4 className="inline-block px-3 py-1 text-sm font-semibold text-purple-700 bg-purple-50 border border-purple-200 rounded-full">
              Teaser 2
            </h4>
            <div className='justify-end flex mb-4'>
                <button
                  name='teaser 2'
                  type='submit'
                  className={joinButtonClasses(dsButtonSecondary, 'h-10 px-4')}
                  onClick={() => onClone(state.pre_launch, 'Teaser 2')}
                >
                  Clone mailer
                </button>
            </div>
          </div>
          <Card style={{ minHeight: 210, marginTop: 20 }} loading={pageloading} className='overview-card relative'>
                    <Row className='font-semibold text-lg'>Teaser 2
                        { !stats.pre_launch?.sent && <span style={{background: '#FEFBED', color: '#D97706'}} className='rounded-xl px-3 py-1 ml-2 font-semibold text-xs'>Optional</span>}
                        <span style={{background: background(stats.pre_launch?.sent), color: textColor(stats.pre_launch?.sent)}} className='rounded-xl px-3 py-1 ml-2 font-semibold text-xs'>
                          {stats.pre_launch?.sent ? 'Sent' : (state.pre_launch?.schedule_time ? 'Scheduled' : 'Draft')}
                        </span>
                    </Row>
                    <Row style={{fontWeight: 400, width: '70%', marginTop: 7}}>
                        To keep the momentum before launch of the product
                    </Row>
                    { !stats.pre_launch?.sent &&
                      <div className='absolute top-6 right-6'>
                    <button
                        name='teaser 2'
                        type='submit'
                        onClick={mailStep}
                        className={joinButtonClasses(dsButtonGhostBrand, 'mx-4 h-10 px-4')}
                    >
                        Edit teaser
                    </button>
                    <Tooltip
                      placement='bottomLeft'
                      overlayStyle={{maxWidth: '235px'}}
                      color={'#0F1115'}
                      key='pink'
                      title={`${!state.pre_launch?.content ? 'Ensure the email content is saved before initiating the teaser 2.' : ''}`}
                      align
                    >
                      {state.pre_launch?.schedule_time ? <></> :
                        <button name='teaser 2' type='submit'
                        disabled={!state.pre_launch?.content}
                        className={joinButtonClasses(dsButtonSecondary, 'h-10 px-4', !state.pre_launch?.content && 'cursor-not-allowed')}
                        onClick={sendMailNowOrLater}>
                          Send now
                      </button>}
                    </Tooltip>
                    </div>}
                    <Row style={{background: '#EFF6FF80'}} className='my-4 px-3 py-3 rounded border-2'>
                        <div className='flex flex-row float-left'>
                          <img src={emailer} alt='#' style={{height: 46, width: 48}}/>
                          <div className='mx-2'>
                            <div className='font-semibold text-base' style={{color: '#0F1115'}}>Subject : {state.pre_launch.subject}</div>
                            <div className=''><strong className='text-slate-800'>{stats.pre_launch?.sent ? 'Sent on' : (state.pre_launch?.schedule_time ? 'Scheduled for' : 'Draft on')}</strong> {stats.pre_launch?.sent ? dateFormat(state.pre_launch?.sent_at) : (state.pre_launch?.schedule_time ? dateFormat(state.pre_launch?.schedule_time) : dateFormat(state.pre_launch?.updated_at))}</div>
                            { !stats.pre_launch?.sent &&
                              <div className='flex items-center'>
                              <button
                                name='teaser 2'
                                onClick={sentTestMail}
                                disabled={!state.pre_launch?.content}
                                className={joinButtonClasses(dsButtonTextAction, !state.pre_launch?.content && dsButtonDisabledTextAction)}
                              >
                                Send Test Mail
                              </button>
                              <div className="bg-zinc-300 rounded mx-2 w-1 h-1 font-semibold" style={{background: '#D1D5DB'}}></div>
                              <button
                                name='teaser 2'
                                onClick={edit_preview}
                                disabled={!state.pre_launch?.content}
                                className={joinButtonClasses(dsButtonTextAction, !state.pre_launch?.content && dsButtonDisabledTextAction)}
                              >
                                Preview
                              </button>
                              </div>}
                          </div>
                        </div>
                        {stats.pre_launch?.sent && metrics(stats.pre_launch)}
                    </Row>
                </Card>
                {state.pre_launch.grade_variants.length > 0 && (
              <div className='mt-4'>
                <h4 className="inline-block px-3 py-1 mt-4 ml-4 text-sm font-semibold text-blue-700 bg-blue-50 border border-blue-200 rounded-full">
                  Replicas
                </h4>
                {renderMailerCard(state.pre_launch.grade_variants, 'teaser 2')}
              </div>
            )}
          </Card>
        </>
      )
    };

    const launchCard = () => {
      const replicas = state.launch.grade_variants.filter((m) => (m?.is_replica && m?.company_mailer_id === state.launch?.id))
      const variants = state.launch.grade_variants.filter((m) => (!m?.is_replica && m?.company_mailer_id === state.launch?.id))

      return(
        <>
          <Card
            style={{ minHeight: 150, marginTop: 20, background: '#F9FAFB' }}
            loading={pageloading}
            className='overview-card relative'
          >
            <div className="flex justify-between items-center">
              <h4 className="inline-block px-3 py-1 text-sm font-semibold text-purple-700 bg-purple-50 border border-purple-200 rounded-full">
                Official Launch
              </h4>
              <div className='justify-end flex mb-4'>
                  <button
                    name='launch'
                    type='submit'
                    className={joinButtonClasses(dsButtonSecondary, 'h-10 px-4')}
                    onClick={() => onClone(state.launch, 'Official Launch')}
                  >
                    Clone mailer
                  </button>
              </div>
            </div>
            <Card style={{ minHeight: 150, marginTop: 20 }} loading={pageloading} className='overview-card relative'>
                  <Row className='font-semibold text-lg'>Official Launch 
                      <span style={{background: background(stats.launch?.sent), color: textColor(stats.launch?.sent)}} className='rounded-xl px-3 py-1 ml-2 font-semibold text-xs'>
                        {stats.launch?.sent ? 'Sent' : (state.launch?.schedule_time ? 'Scheduled' : 'Draft')}
                      </span>
                  </Row>
                    <Row style={{fontWeight: 400, width: '70%', marginTop: 7}}>
                        On the day of the official launch to keep informed all the employees about the services, benefits and how to avail of them an official communication gets sent to them. 
                    </Row>
                    { !stats.launch?.sent &&
                      <div className='absolute top-6 right-6'>
                        <button
                            name='launch'
                            type='submit'
                            onClick={(e) => mailStep(e, 'launch')}
                            className={joinButtonClasses(dsButtonGhostBrand, 'mx-4 h-10 px-4')}
                        >
                        Edit emailer
                    </button>
                    {!disableGradeSendButton &&
                    <Tooltip
                      placement='bottomLeft'
                      overlayStyle={{maxWidth: '235px'}}
                      color={'#0F1115'}
                      key='pink'
                      title={`${!state.launch?.content || disableSendButton ? 'Ensure the email content is saved before initiating the launch.' : ''}`}
                      align
                    >
                      {state.launch?.schedule_time ? <></> :
                        <button name='launch' type='submit'
                        disabled={!state.launch?.content || disableSendButton}
                        className={joinButtonClasses(dsButtonSecondary, 'h-10 px-4', (!state.launch?.content || disableSendButton) && 'cursor-not-allowed')}
                        onClick={sendMailNowOrLater}>
                          Send now
                      </button>}
                    </Tooltip>}
                    </div>}
                    <Row style={{background: '#EFF6FF80'}} className='my-4 px-3 py-3 rounded border-2'>
                        <div className='flex flex-row float-left'>
                          <img src={emailer} alt='#' style={{height: 46, width: 48}}/>
                          <div className='mx-2'>
                            <div className='font-semibold text-base' style={{color: '#0F1115'}}>Subject : {state.launch.subject}</div>
                            <div className=''><strong className='text-slate-800'>{stats.launch?.sent ? 'Sent on' : (state.launch?.schedule_time ? 'Scheduled for' : 'Draft on')}</strong> { stats.launch?.sent ? dateFormat(state.launch?.sent_at) : (state.launch?.schedule_time ? dateFormat(state.launch?.schedule_time) : dateFormat(state.launch.updated_at))}</div>
                            { !stats.launch?.sent &&
                              <div className='flex items-center'>
                                <button
                                  name='launch'
                                  onClick={sentTestMail}
                                  disabled={!state.launch?.content}
                                  className={joinButtonClasses(dsButtonTextAction, !state.launch?.content && dsButtonDisabledTextAction)}
                                >
                                  Send Test Mail
                                </button>
                                <div className="bg-zinc-300 rounded mx-2 w-1 h-1 font-semibold" style={{background: '#D1D5DB'}}></div>
                                <button
                                  name='launch'
                                  onClick={edit_preview}
                                  disabled={!state.launch?.content}
                                  className={joinButtonClasses(dsButtonTextAction, !state.launch?.content && dsButtonDisabledTextAction)}
                                >
                                  Preview
                                </button>
                              </div>}
                          </div>
                        </div>
                        {stats.launch?.sent && metrics(stats.launch)}
                    </Row>
                    { variants.length > 0 &&
                      <div  
                      onClick={toggleCollapse}
                      style={{background: '#EFF6FF',}}
                      className="float-right flex flex-row items-center cursor-pointer mt-2.5 px-4 py-1.5 rounded-lg transition-all duration-300 ease-in-out"
                    >
                      <VibratingArrow
                        src={downArrow}
                        alt="Arrow"
                      />
                      <span className="text-blue-600 font-fig-semibold text-sm">Expand to view grade mailers</span>
                    </div>
                    }
                </Card>
                {replicas?.length > 0 && (
              <div className='mt-4'>
                <h4 className="inline-block px-3 py-1 mt-4 ml-4 text-sm font-semibold text-blue-700 bg-blue-50 border border-blue-200 rounded-full">
                  Replicas
                </h4>
                {renderMailerCard(replicas, 'launch')}
              </div>
            )}
          </Card>
        </>
      )
    }

    function flattenReplicaMailers(mailer, maxDepth = 3, currentDepth = 0) {
      if (!mailer || currentDepth >= maxDepth) return [];

      const children = mailer.grade_variants || [];

      return [
        mailer,
        ...children.flatMap(child => flattenReplicaMailers(child, maxDepth, currentDepth + 1))
      ];
    }

    const closeModal = () => {
      setSendModal((prev) => {return {...prev, disable: false}})
    }

    const toggleCollapse = () => {
      setCollapsed(!collapsed);
    };

    const background = (val = false) => {return(val ? '#E6F3F0' : '#EFF6FF')}
    const textColor = (val = false) => {return(val ? '#14866D' : '#475569')}

    const flattenMailers = flattenReplicaMailers(state.launch);
    const disableSendButton = state.launch?.grade_variants?.some((item) => !item.content && !item.is_replica)
    const disableGradeSendButton = state.launch?.grade_variants?.some((item) => (item.status == 'sent' && item.sent_at) || (item.status == 'scheduled' && item.schedule_time));

    const employee_count = sendModal.employee_count[sendModal.type] || Object.values(sendModal.employee_count).reduce((sum, val) => sum + val, 0);

    return(
        <Spinner visible={pageloading}>
          { cloneModal.open &&
              <PopUpModals
                title={['Clone ', cloneModal.mailerName ,' Mailer Template']}
                classes='w-1/3'
                description={["Create a copy of ",<strong className='capitalize'> {cloneModal.mailerName} mailer. </strong>,' - to reuse its layout and content for another campaign or audience.']}
                onCancel='do not clone'
                onPass='clone'
                icon={file}
                onClose={closeCloneModal}
                onSave={cloneMailer}
              />
          }
          { test.testMail && 
            <TestMailModal 
              title='Send a Test Email' 
              description='Send a test to' 
              onClose={testMailFunc} 
              onSave={sendTest} 
              inputVal={(val) => {setTest((prev) => {return{...prev,...{mail: val}}})}} 
            />
          }
          { sendModal.send &&
            <PopUpModals 
              title={['Review ',sendModal.type]}
              description={["You are about to send the ",sendModal.type === 'teaser 1' ? <strong>first</strong> : <strong>second</strong>, <strong> teaser mail. </strong>,"It will help your employees know that something ", <strong>new</strong>, " and ",<strong>big</strong>," is coming"]}
              onCancel='Send it later'
              onPass='Send now'
              icon={review_mailer}
              onClose={closeSendModal}
              onSave={mail_sender}
            />
          }
           { sendModal.launch &&
            <LaunchMailerModal 
              title='Congratulations!'
              description={"Your workplace is going to take a big step toward becoming a healthier place in no time"}
              onPass='Launch now'
              launch={true}
              onClose={closeSendModal}
              onSave={launchMailSent}
              confetti={static_confetti}
              close_icon={close_copy}
            />
          }
          { (sendModal.launchSent) &&
            <LaunchMailerModal 
              title='Congratulations!'
              description={["On taking steps to keep your employees healthy. ",
              <span className='text-blue-600 font-bold'><br/>{employee_count} employees</span>,
              " in your company now have access to",<strong> health<br/> benefits via ekincare</strong>]}
              icon={mile_stone}
              onClose={launchDone}
              onSave={launchDone}
              confetti={confetti}
              close_icon={close_icon}
            />
          }
          <FailModal
            visible={sendModal.disable}
            title='Missing employee list'
            description='Mails cannot be sent because employees are not added.'
            btntext='Okay'
            close={closeModal}
            btnhandler={closeModal}
            missing={true}
          />
            <div>
                <Breadcrumb list={[{ text:'Pre Launch', link:'/mailer' }, { text:'Mailers', link:'#' }]} classes='mb-1' />
                <Heading mainHeading="Pre Launch" classes='mt-2'/>
                <p className='text-sm font-normal'>Plan the launch experience for your employees' health benefits</p>
                {teaserCard()}
                {preLaunchCard()}
                { collapsed ?
                    <Card style={{ minHeight: 150, marginTop: 20 }} loading={pageloading} className='overview-card relative'>
                    <Row className='font-semibold text-lg'>Official Launch 
                        <span style={{background: background(stats.launch?.sent), color: textColor(stats.launch?.sent)}} className='rounded-xl px-3 py-1 ml-2 font-semibold text-xs'>
                          {stats.launch?.sent ? 'Sent' : (state.launch?.schedule_time ? 'Scheduled' : 'Draft')}
                        </span>
                    </Row>
                    {/* <Row style={{fontWeight: 400, width: '70%', marginTop: 7}}>
                        On the day of the official launch to keep informed all the employees about the services, benefits and how to avail of them an official communication gets sent to them. 
                    </Row> */}
                    { !stats.launch?.sent &&
                      <div className='absolute top-6 right-6'>
                        {/* <button
                            name='launch'
                            type='submit'
                            onClick={mailStep}
                            className='inline-flex right-8 items-center mx-4 px-4 py-3 text-base font-semibold rounded-md text-blue-700 hover:bg-blue-50 transition'
                        >
                        Edit emailer
                    </button> */}
                    { !disableGradeSendButton &&
                      <Tooltip
                      placement='bottomLeft'
                      overlayStyle={{maxWidth: '235px'}}
                      color={'#0F1115'}
                      key='pink'
                      title={`${!state.launch?.content || disableSendButton ? 'Ensure the email content is saved before initiating the launch.' : ''}`}
                      align
                    >
                      {state.launch?.schedule_time ? <></> :
                        <button name='launch' type='submit' 
                        disabled={!state.launch?.content || disableSendButton}
                        className={joinButtonClasses(dsButtonSecondary, 'h-10 px-4', (!state.launch?.content || disableSendButton) && 'cursor-not-allowed')}
                        onClick={sendMailNowOrLater}>
                          Send now
                      </button>}
                    </Tooltip>}
                    </div>}
                    <MailerCard mailStep={mailStep} sentTestMail={sentTestMail} sendMailNowOrLater={sendMailNowOrLater} launched={sendModal.activate > 0} activatedCount={sendModal.activate} pageloading={pageloading} edit_preview={edit_preview} 
                              mailerData={flattenMailers} stats={[...(stats.launch ? [stats.launch] : []), ...(stats.launch?.grade_variants || [])]} onClone={onClone} />
                    <div  
                      onClick={toggleCollapse}
                      style={{background: '#EFF6FF'}}
                      className="float-right flex flex-row items-center cursor-pointer mt-2.5 px-4 py-1.5 rounded-lg transition-all duration-300 ease-in-out"
                    >
                      <VibratingArrow
                        src={upArrow}
                        alt="Arrow"
                      />
                      <span className="text-blue-600 font-fig-semibold text-sm">Collapse</span>
                    </div>
                </Card>
                  :
                  <>{launchCard()}</>
                }
            </div>
        </Spinner>
    )

}

export default MailLandingPage;
